export default "__VITE_ASSET__5947a681__"